import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7z2alyc1: FaireBrandEntity = {
  token: "b_7z2alyc1",
  type: "brand",
  name: "And Here We Are",
  avatarUrl:
    "https://cdn.faire.com/fastly/6f0ceeeca156c38aaab1ab5ee1ffebd8a1cbd33c4819c3a039a52f6a5faa7a33.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/af3f66a5346671c02dedd23a150b3b0a17db32a86ba96625e370d021e090c1a3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6f0ceeeca156c38aaab1ab5ee1ffebd8a1cbd33c4819c3a039a52f6a5faa7a33.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/af3f66a5346671c02dedd23a150b3b0a17db32a86ba96625e370d021e090c1a3.png",
  location: "Columbus, OH, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 109,
  isTopShop: true,
  isInsider: true,
  description:
    "And Here We Are® creates modern, colorful, hand-printed greeting cards, notebooks, stationery, and gifts from our letterpress studio in Columbus, Ohio. Our best-selling products are perfect for anyone looking for fun, thoughtful, unique, or handmade gifts at an approachable price point. We are proudly woman owned and operated.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:03.918Z",
    importedBy: "entity-db-cli",
  },
};
